// ** Icon Imports
import { Icon, IconProps } from '@iconify/react'

const IconifyIcon = ({ icon, fontSize, ...rest }: IconProps) => {
    return <Icon icon={icon} {...rest} style={{fontSize}}/>
}

export default IconifyIcon
